import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    addEmailLabel: 'Email missing',
    addEmailNote: 'Add the email address of the beneficiaries',

    doneTitle: 'Completed by the beneficial owners',

    waitingText:
      'Beneficial owners must complete their information so that we can verify your application.',
    waitingTitle: 'To be completed by the beneficial owners',
  },

  fr: {
    addEmailLabel: 'Email manquant',
    addEmailNote: "Ajouter l'adresse mail des benéficiaires",

    doneTitle: 'Complétés par les bénéficiaires effectifs',

    waitingText:
      'Les bénéficiaires effectifs doivent renseigner leurs informations pour que nous puissions vérifier votre dossier.',
    waitingTitle: 'À compléter par les bénéficiaires effectifs',
  },
} as const);
